import React, { useState, useEffect } from 'react';
import styles from '../../styles/RolesPermissionsStyles/RolesPermissions.module.css';
import { getInstituciones } from '../../api/roles';

function NewRoleModal({ isOpen, onClose, onSave }) {
  const [instituciones, setInstituciones] = useState([]);
  const [formData, setFormData] = useState({
    nombre_rol: '',
    descripcion: '',
    id_institucion: '',
    ambito_visualizacion: 'INSTITUCION',
    nivel_acceso: 1,
    activo: true
  });

  useEffect(() => {
    if (isOpen) {
      loadInstituciones();
      // Reset form
      setFormData({
        nombre_rol: '',
        descripcion: '',
        id_institucion: '',
        ambito_visualizacion: 'INSTITUCION',
        nivel_acceso: 1,
        activo: true
      });
      
      // Focus en el input cuando se abre el modal
      setTimeout(() => {
        const input = document.getElementById('newRoleNameInput');
        if (input) {
          input.focus();
        }
      }, 100);
    }
  }, [isOpen]);

  const loadInstituciones = async () => {
    try {
      const data = await getInstituciones();
      setInstituciones(data);
      
      // Seleccionar primera institución por defecto
      if (data.length > 0) {
        setFormData(prev => ({
          ...prev,
          id_institucion: data[0].id_institucion
        }));
      }
    } catch (error) {
      console.error('Error al cargar instituciones:', error);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    if (formData.nombre_rol.trim() && formData.id_institucion) {
      onSave(formData);
    } else {
      alert('Por favor complete los campos requeridos');
    }
  };

  const handleCancel = () => {
    setFormData({
      nombre_rol: '',
      descripcion: '',
      id_institucion: '',
      ambito_visualizacion: 'INSTITUCION',
      nivel_acceso: 1,
      activo: true
    });
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Nuevo Rol</h2>
        </div>
        
        <div className={styles.modalContent}>
          <div className={styles.modalField}>
            <label className={styles.modalFieldLabel} htmlFor="newRoleNameInput">
              Nombre del rol *
            </label>
            <input
              id="newRoleNameInput"
              type="text"
              className={styles.modalInput}
              value={formData.nombre_rol}
              onChange={(e) => handleInputChange('nombre_rol', e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ingrese el nombre del rol"
              autoComplete="off"
            />
          </div>

          <div className={styles.modalField}>
            <label className={styles.modalFieldLabel}>
              Descripción
            </label>
            <textarea
              className={styles.modalInput}
              value={formData.descripcion}
              onChange={(e) => handleInputChange('descripcion', e.target.value)}
              placeholder="Descripción del rol (opcional)"
              rows={3}
            />
          </div>

          <div className={styles.modalField}>
            <label className={styles.modalFieldLabel}>
              Institución *
            </label>
            <select
              className={styles.modalInput}
              value={formData.id_institucion}
              onChange={(e) => handleInputChange('id_institucion', parseInt(e.target.value))}
            >
              <option value="">Seleccione una institución</option>
              {instituciones.map(inst => (
                <option key={inst.id_institucion} value={inst.id_institucion}>
                  {inst.nombre_institucion}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.modalField}>
            <label className={styles.modalFieldLabel}>
              Ámbito de visualización
            </label>
            <select
              className={styles.modalInput}
              value={formData.ambito_visualizacion}
              onChange={(e) => handleInputChange('ambito_visualizacion', e.target.value)}
            >
              <option value="INSTITUCION">Toda la institución</option>
              <option value="MULTI_CAMPUS">Múltiples campus</option>
              <option value="SOLO_CAMPUS">Solo campus</option>
            </select>
          </div>
        </div>
        
        <div className={styles.modalActions}>
          <button 
            className={styles.modalButtonPrimary}
            onClick={handleSave}
            disabled={!formData.nombre_rol.trim() || !formData.id_institucion}
          >
            CREAR ROL
          </button>
          <button 
            className={styles.modalButtonSecondary}
            onClick={handleCancel}
          >
            CANCELAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default NewRoleModal;
